import { LoginRedirect } from './LoginRedirect';

document.addEventListener('DOMContentLoaded', function () {
  window.Webflow ||= [];

  window.Webflow.push(async () => {
    const app = new LoginRedirect();
    app.init();
    document.documentElement.classList.add('webflow-loaded');
  });
});
